import { Mark } from '@tiptap/core';

const Image = Mark.create({
  name: 'image',

  addCommands() {
    return {
      addImage: (id) => ({ commands }) => commands.insertContent(`[IMG:${id}]`),
    };
  },
});

export default Image;
